import React from 'react';

import { toast, GlobalCableToastContent } from '.';
import Button from '../Buttons/Button';

const appCableSubscribe = ({ channel, token, ...restParams }, {
  onReceived,
}) => {
  App.cable.subscriptions.create({ channel, ...restParams }, {
    received: onReceived,
  });
};

const prospectorReportsSubscribe = ({ channel, token }) => {
  appCableSubscribe({ channel, token }, {
    onReceived: (data) => {
      if (data.status === 'done' && data.status === 'done') {
        toast.success((
          <GlobalCableToastContent
            title="List Updated"
            description={`Your list "${data.report_name}" has been updated`}
            renderButton={({ closeToast }) => (
              <Button
                variant="light"
                href={`/prospector?id=${data.report_id}`}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => closeToast()}
              >
                View List
              </Button>
            )}
          />
        ));
      }
    },
  });
};

const globalCableSubscription = () => {
  const rootNode = document.getElementById('global-cable-toasts-root');
  const channels = JSON.parse(rootNode.dataset.channels || '[]');
  const token = (() => {
    const userToken = document.getElementsByName('user_token')[0];
    return userToken ? (userToken.getAttribute('content') || '') : '';
  })();

  if (!channels.length || !token.length) return;

  App.initCable(token);

  channels.forEach((channel) => {
    switch (channel) {
      case 'ProspectorReportsChannel':
        prospectorReportsSubscribe({ channel, token });
        break;
      default:
        break;
    }
  });
};

document.addEventListener('DOMContentLoaded', () => {
  globalCableSubscription();
});
